import { useState } from "react";
import Chart from "react-apexcharts";
import { Grid, Button, Dialog, Divider, Box, Typography } from "@mui/material";
import NormalTable from "../../Component/NormalTable";
import { color } from "../../StyleData/Config";
import { masterAPI } from "../Masters/dataConfig";
import { axiosPrivate } from "../../axios/axios";
import { toUTC, fromUTC } from "../../utils/dateUtil";

const columns = [
  { Header: "WO", accessor: "workOrderCode" },
  {
    Header: "Stop Begin Date",
    accessor: "stopBeginDate",
    Cell: ({ cell }) =>
      cell.value !== null && cell.value !== undefined ? fromUTC(cell.value).tzString : "-",
  },
  {
    Header: "Stop End Date",
    accessor: "stopEndDate",
    Cell: ({ cell }) =>
      cell.value !== null && cell.value !== undefined ? fromUTC(cell.value).tzString : "-",
  },
  { Header: "Downtime", accessor: "downTime", Cell: ({ cell }) => cell.value != null ? parseFloat(Number(cell.value).toFixed(2)) : "" },
  { Header: "Status", accessor: "status" },
  { Header: "Work Type", accessor: "workType" },
  { Header: "Asset Code", accessor: "assetCode" },
  { Header: "Act Labour", accessor: "actualLabour", Cell: ({ cell }) => cell.value != null ? parseFloat(Number(cell.value).toFixed(2)) : "" },
  { Header: "Prior Meter Reading", accessor: "startMeterReading" },
  { Header: "Current Meter Reading", accessor: "currentMeterReading" },
  // { Header: "Installation Date", accessor: "installationDate" },
];

const MTTRChart = ({ dashBoardDatamttXaxis, dashBoardDatamttYaxis, type, dateFrom, dateTo }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState("");

  const handleBarClick = (e, chartContext, config) => {
    const dataPointIndex = config?.dataPointIndex;
    if (dataPointIndex !== undefined && dataPointIndex >= 0) {
      const assetCode = dashBoardDatamttYaxis[dataPointIndex];
      setSelectedAsset(assetCode);
      const endpoint = masterAPI["KPIReport"].getMTBFAndMTTRReportList;
      axiosPrivate
        .post(endpoint, {
          assetCode,
          createdDateFrom: toUTC(dateFrom).utcISOString,
          createdDateTo: toUTC(dateTo).utcISOString,
        })
        .then((res) => {
          setListData(res.data.result || []);
          setDialogOpen(true);
        })
        .catch((e) => {
          console.log(e);
          setListData([]);
          setDialogOpen(true);
        });
    }
  };

  const handleClose = () => {
    setDialogOpen(false);
    setSelectedAsset("");
    setListData([]);
  };

  const maxValue = dashBoardDatamttXaxis.length ? Math.max(...dashBoardDatamttXaxis) : 0;
  const axisMax = Math.max(1, Math.ceil(maxValue));

  return (
    <>
      <Chart
        height={type ? (dashBoardDatamttXaxis.length ? `${32 * dashBoardDatamttYaxis.length + 200}px` : "100%") : 200}
        width={"100%"}
        options={{
          title: {
            text: "Mean Time To Repair",
            style: { fontFamily: "Nunito Sans, sans-serif", color: "#2362B4" },
          },
          noData: {
            text: "No Data Available",
            align: "center",
            verticalAlign: "middle",
            style: { color: "#999", fontSize: "14px", fontFamily: "Nunito Sans, sans-serif" },
          },
          chart: {
            type: "bar",
            toolbar: {
              export: {
                csv: { filename: "MTTR" },
                svg: { filename: "MTTR" },
                png: { filename: "MTTR" },
              },
            },
            events: type ? { dataPointSelection: handleBarClick } : {},
          },
          plotOptions: { bar: { borderRadius: 4, horizontal: true } },
          dataLabels: { enabled: false },
          tooltip: {
            y: {
              formatter: (val) => Number(val).toFixed(1),
            },
          },
          yaxis: { title: { text: "Asset" } },
          xaxis: {
            title: { text: "Hours", style: { fontSize: "11px" } },
            categories: dashBoardDatamttYaxis,
            min: 0,
            max: axisMax,
            tickAmount: axisMax,
            labels: {
              formatter: (val) => (typeof val === "number" ? Math.round(val) : val),
            },
          },
        }}
        type="bar"
        series={[{ data: dashBoardDatamttXaxis }]}
      />

      <Dialog open={dialogOpen} onClose={handleClose} maxWidth="xl" fullWidth>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              sx={{
                color: color.masterPageTitleColor,
                fontSize: color.masterPageTitleFontSize,
                fontWeight: color.masterPageTitleFontWeight,
                mb: color.masterPageTitlemd,
                px: 2,
                py: 1,
              }}
            >
              MTTR — Asset:{" "}
              <span style={{ color: color.masterDialogTitleColor }}>{selectedAsset}</span>
            </Typography>
            <Box sx={{ px: 2, py: 1 }}>
              {listData.length === 0 ? (
                <Typography sx={{ textAlign: "center", color: "#999", fontSize: "14px", py: 4 }}>
                  No Data Available
                </Typography>
              ) : (
                <NormalTable data={listData} columns={columns} filt={true} />
              )}
            </Box>
          </Grid>
          <Divider />
          <Grid container item justifyContent="flex-end">
            <Button onClick={handleClose}>Close</Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default MTTRChart;
